export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7659.fd3e57ff.jpg";